module.exports = __webpack_public_path__ + "static/media/hifz.f2fc8078.png";